import { mainWeb, mainWebResource } from '../../config/net'

const reveiveCoupon = {
  url: `${mainWeb}${mainWebResource}`,
  method: 'receivecoupon'
}

const receiveStatus = {
  url: `${mainWeb}${mainWebResource}`,
  method: 'receivestatus'
}

const mainWebUrl = `${mainWeb}/OnlineMall/ajax/MobileOnlineMall.ashx`
export default {
  reveiveCoupon,
  mainWebUrl,
  receiveStatus
}



// WEBPACK FOOTER //
// ./src/model/christmas/resource-url.js